module.exports = __webpack_public_path__ + "img/Vanuatu.39c54148.gif";